<template>
  <div class="form-builder-root">
    <form-builder-template
      v-if="type === 'template'"
      ref="FormBuilderTemplate"
      :form="form"
      :autonomous="autonomous"
      :gridId="gridId"
      :rowData="rowData"
    />
    <form-builder-gui
      v-else-if="type === 'gui'"
      ref="FormBuilderGui"
      :form="form"
      :gridId="gridId"
    />
    <div v-else>
      <p>
        Type not found, did you enter correct type
        <b>(template, gui)</b>?
      </p>
    </div>
  </div>
</template>

<script>
// load js
if (require) {
  require('./config/loader')
}

// load necessary
import { Hooks as GUI_Hooks } from './gui/components/hook_lists'
import { Hooks as Template_Hooks } from './template/components/hook_lists'
import { FormHandler } from '@/components/DataGrid/FormBuilder/gui/handler/form_handler'

// import
import FormBuilderTemplate from './template/FormBuilderTemplate'
import FormBuilderGui from './gui/FormBuilderGui'

// special hook
import { ValidateSettingHandler } from '@/components/DataGrid/FormBuilder/template/handler/validate_setting_handler'
import { CONTROL_TYPES } from '@/components/DataGrid/FormBuilder/config/control_constant'
import { FORM_CONSTANTS } from '@/components/DataGrid/FormBuilder/config/constants'
import { mapState } from 'vuex'
// helpers
import eventBus from '@/helpers/event-bus'

export default {
  name: 'FormBuilder',
  components: {
    FormBuilderTemplate,
    FormBuilderGui,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    type: {
      type: String,
      default: 'template',
    },
    form: {
      type: Object,
      default: () => ({
        sections: [],
        layout: '',
        _uniqueId: Math.random(),
      }),
    },
    value: null,
    options: {
      type: Object,
      default: () => ({}),
    },
    autonomous: {
      type: Boolean,
      default: false,
    },
    gridId: {
      type: String,
    },
    rowKey: {
      type: String,
    },
  },
  data() {
    return {
      rowData: null,
    }
  },
  computed: {
    ...mapState(['dataGrid_options']),
  },
  watch: {
    form: {
      handler(val) {
        if (this.type === 'template') {
          this.$emit('change', val)
        } else {
          this.debounceGetFormGUIValue()
        }
      },
      deep: true,
    },
    value(val) {
      this.setValue(val)
    },
  },
  methods: {
    getValue() {
      if (this.type === 'template') {
        return this.$refs.FormBuilderTemplate.getValue()
      } else {
        if (!_.accessStr(this, '$refs.FormBuilderGui')) {
          return
        }

        return this.$refs.FormBuilderGui.getValue()
      }
    },
    setValue(values) {
      if (_.isEmpty(values)) return

      // set values for specific type
      if (this.type === 'template') {
        // _.deepExtend(this.form, FormHandler.recorrectStructure(values));
        _.extend(this.form, FormHandler.recorrectStructure(values))
        // this.$refs.FormBuilderTemplate.setValue(values);
      } else {
        this.$refs.FormBuilderGui.setValue(values)
      }
    },
    validate(showError = true) {
      if (this.type !== 'gui') {
        return
      }

      var hasError = FormHandler.validate(this.form)

      if (showError && hasError) {
        const message = 'There are errors on the page. Please rectify the errors so the action can be completed.'

        this.$bvToast.toast(message, {
          title: 'Failed!',
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 2500,
        })
      }

      this.$emit('validate')

      // true => no error | false => errors
      return !hasError
    },
    clearError() {
      FormHandler.clearErrorField()
    },
    setRowDataVal(cellKey, val) {
      if (typeof val !== 'undefined') {
        this.rowData[cellKey] = val
      }

      if (
        this.dataGrid_options[this.gridId].isReactive ||
        typeof this.dataGrid_options[this.gridId].isReactive === 'undefined'
      )
        this.$emit('rowDataChanged', cellKey, val)
    },
    dgCellChanged(gridId, rowKey, cellKey, value) {
      if (gridId !== this.gridId || rowKey !== this.rowKey) return

      if (this.gridId && this.rowKey) {
        //console.log('about to clone' + this.gridId  + this.rowKey)
        this.rowData = _.cloneDeep($dataGrid(this.gridId)[this.rowKey])
      } else {
        this.rowData = null
      }

      this.$emit('dgCellChanged', cellKey, value)
    },
  },
  created() {
    let self = this
    this.debounceGetFormGUIValue = _.debounce(() => {
      if (typeof self === 'undefined' || typeof self.getValue === 'undefined') {
        return
      }

      self.$emit('change', self.getValue())
    }, 500)

    // Register for hook
    if (this.type === 'template') {
      if (_.has(this.options, 'hooks')) {
        Template_Hooks.register(this.options.hooks)
      }

      // add special hooks for template
      ValidateSettingHandler.init(Template_Hooks)
    } else {
      if (_.has(this.options, 'hooks')) {
        GUI_Hooks.register(this.options.hooks)
      }

      // Re-correct data for GUI
      // _.deepExtend(this.form, FormHandler.recorrectStructure(this.form));
      _.extend(this.form, FormHandler.recorrectStructure(this.form))
    }

    // extends for controls
    if (_.has(this.options, 'moreControls')) {
      _.each(this.options.moreControls, (item, key) => {
        // won't add existed
        if (CONTROL_TYPES[key]) {
          // console.error('EXISTED CONTROL KEY: ' + key);
          return
        }

        FORM_CONSTANTS.Type[key] = {
          label: item.label,
          icon: item.icon,
        }

        CONTROL_TYPES[key] = item
      })
    }

    if (this.gridId && this.rowKey) {
      //console.log('about to clone' + this.gridId  + this.rowKey)
      this.rowData = _.cloneDeep($dataGrid(this.gridId)[this.rowKey])
    } else {
      this.rowData = null
    }

    eventBus.$on('dgCellChanged', this.dgCellChanged)
  },
  mounted() {
    this.setValue(this.value)
  },
  beforeDestroy() {
    eventBus.$off('dgCellChanged', this.dgCellChanged)
  },
}
</script>
